(function () {
	'use strict';

	angular.module('mx.shell').component('mxExtraPanel', {
		bindings: { view: '<' },
		templateUrl: 'components/mx-extra-panel/mx-extra-panel.html',
		controllerAs: 'vm',
		controller: MxExtraPanelCtrl,
	});

	MxExtraPanelCtrl.$inject = ['mx.shell.ExtraPanelManager'];

	function MxExtraPanelCtrl(mxExtraPanelManager) {
		var vm = this;

		vm.$onInit = function () {
			vm.mxExtraPanelManager = mxExtraPanelManager;
		};
	}
})();
